import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import {
  Grid,
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography,
  Button,
  IconButton,
  FormHelperText,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import * as Yup from 'yup';

import useStyles from 'components/generals/forms/register/styles';
import MyOutlinedTextField from 'components/generals/input/MyOutlinedTextField';

import { closeModal } from 'store/ducks/nav/actions';
import { useDialogStyles } from './useStyles';
import { SetCustomTransportDialogProps } from './dialogTypes';
import TransportService from 'services/transportService';

const validationSchema = Yup.object({
  transport: Yup.string(),
});

const SetCustomTransportInResendOrdersDialog: FC<SetCustomTransportDialogProps> = props => {
  const dispatch = useDispatch();
  const styles = useStyles();
  const classes = useDialogStyles();
  const { title, message, orderIds } = props;

  const { handleSubmit, errors, control } = useForm({
    validationSchema,
  });

  const onSubmit = async ({ transport }: Record<string, string>) => {
    try {
      await TransportService.handleSetTransportInResendOrders(
        transport,
        transport,
        orderIds,
      );

      window.location.reload();
      dispatch(closeModal());
    } catch (err) {
      throw new Error(err);
    }
  };

  return (
    <Grid container direction="column">
      <DialogTitle disableTypography>
        <Grid container justify="space-between" alignItems="center">
          <Typography variant="h1" color="textPrimary">
            {title}
          </Typography>
          <IconButton onClick={() => dispatch(closeModal())}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={2}
          component="form"
          className={classes.paddingInfoBottom}
        >
          <Grid item xs={12} sm={12} md={12}>
            <Typography
              variant="h4"
              color="textPrimary"
              className={classes.info}
              style={{ whiteSpace: 'pre-wrap' }}
            >
              {message}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Controller
              as={<MyOutlinedTextField multiline />}
              required
              fullWidth
              control={control}
              name="transport"
              label="Transportadora"
              error={Boolean(errors.transport)}
            />
            {errors.boxWeight && (
              <FormHelperText>
                <Typography variant="h5" color="primary">
                  {errors.transport.message}
                </Typography>
              </FormHelperText>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={`${styles.buttonLabel} ${styles.buttonWrapper}`}
          onClick={handleSubmit(onSubmit)}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Grid>
  );
};

export default SetCustomTransportInResendOrdersDialog;
